import { useNavigate } from "react-router-dom";
import { BusinessSupplierConsent } from "../../../../components/common";
import { pathConstants } from "../../../../routes/pathContants";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";

export const BusinessSupplierConsentHome = () => {
  const navigate = useNavigate();
  return (
    <div className={`${globalStyles.pagePaddings}`}>
      <div
        className="mx-auto white p-4 mt-5"
        style={{ maxWidth: "750px", borderRadius: "12px" }}
      >
        <BusinessSupplierConsent
          closeModal={() => navigate(pathConstants.DASHBOARD_MAIN)}
        />
      </div>
    </div>
  );
};
